export function isFunction(val: unknown): val is Function {
    return typeof val === 'function'
}


export function isUndefined(value: any): value is undefined {
    return value === undefined;
}